import HomePage from "./page/Home";
import ResultsPage from "./page/Results";
import faqPage from "./page/FAQ";
import ResponsiblePage from "./page/Responsible";
import Aboutpage from "./page/About";
import ContactPage from "./page/Contact";
import PrivacyPage from "./page/Privacy";
import PageNotFound from "./page/404";
import AdminPage from "./page/Admin";
import LoginPage from "./page/Login";

const routes = [
  {
    path: "/",
    redirect: '/home'
  },
  {
    path: "/home",
    component: HomePage
  },
  {
    path: "/result",
    redirect: "/results"
  },
  {
    path: "/results",
    component: ResultsPage
  },
  {
    path: "/faq",
    component: faqPage
  },
  {
    path: "/about-us",
    component: Aboutpage
  },
  {
    path: "/responsible-gambling",
    component: ResponsiblePage
  },
  {
    path: "/contact-us",
    component: ContactPage
  },
  {
    path: "/privacy-policy",
    component: PrivacyPage
  },
  {
    path: "/halaman-belakang",
    component: AdminPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/gogogo",
    component: LoginPage
  },
  {
    path: "*",
    component: PageNotFound
  }
];

export default routes;
